var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('SrNotification',_vm._b({attrs:{"type":"error","title":_vm.error},on:{"close":_vm.close}},'SrNotification',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }